
<div class="p-2 busy-overlay-parent" [ngClass]="isLoading?'disabled':''">

    <div *ngIf="isLoading || bSyncing" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Syncing Buildings...
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
        {{errorMsg}}
        <div role="button" (click)="errorMsg=''"><i class="fa fa-times"></i></div>
    </div>

    <div *fesListView="let filteredBuildings of rxBuildings">
        <h5>RxDB Buildings</h5>
        <div class="d-flex">
            <button class="btn btn-secondary btn-sm m-1 mr-auto" (click)="clearBuildings()">Rebuild</button>
            <a href="javascript:false;" (click)="loadBuildings()"><i class="fas fa-sync"></i>&nbsp;Refresh</a>
        </div>
        <table class="table table-striped table-bordered table-sm">
            <thead>
                <tr>
                    <th fesSortField="id">id</th>
                    <th fesSortField="market">market</th>
                    <th fesSortField="morphology">morphology</th>
                    <th fesSortField="characteristics">characteristics</th>
                    <th fesSortField="commonName">commonname</th>
                    <th fesSortField="civicAddress">civicaddress</th>
                    <th fesSortField="civicLatitude">civiclatitude</th>
                    <th fesSortField="civicLongitude">civiclongitude</th>
                    <th fesSortField="construction">construction</th>
                    <th fesSortField="updatedAt">updatedat</th>
                    <th fesSortField="deleted">deleted</th>
                    <!-- <th></th> -->
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><input fesFilterField="id"class="small w-100" /></td>
                    <td><input fesFilterField="market"class="small w-100" /></td>
                    <td><input fesFilterField="morphology"class="small w-100" /></td>
                    <td><input fesFilterField="characteristics"class="small w-100" /></td>
                    <td><input fesFilterField="commonName"class="small w-100" /></td>
                    <td><input fesFilterField="civicAddress"class="small w-100" /></td>
                    <td><input fesFilterField="civicLatitude"class="small w-100" /></td>
                    <td><input fesFilterField="civicLongitude"class="small w-100" /></td>
                    <td><input fesFilterField="construction"class="small w-100" /></td>
                    <td><input fesFilterField="updatedAt"class="small w-100" /></td>
                    <td><input fesFilterField="deleted"class="small w-100" /></td>
                    <!-- <td></td> -->
                </tr>
                <tr *ngFor="let building of filteredBuildings;">
                    <td>{{building.id}}</td>
                    <td>{{building.market}}</td>
                    <td>{{building.morphology}}</td>
                    <td>{{building.characteristics}}</td>
                    <td>{{building.commonName}}</td>
                    <td>{{building.civicAddress}}</td>
                    <td>{{building.civicLatitude}}</td>
                    <td>{{building.civicLongitude}}</td>
                    <td>{{building.construction}}</td>
                    <td>{{building.updatedAt|date:'yyyy-MM-dd HH:mm:ss'}}</td>
                    <td>{{building.deleted}}</td>
                    <!-- <td class="text-center align-middle">
                        <a class="text-nowrap" href="javascript:false;" (click)="editBuilding(building)">edit</a>
                    </td> -->
                </tr>
            </tbody>
        </table>
    </div>

</div>
